export function generateDomainFromUrl(url = '') {
  const REGEX_GET_DOMAIN = /.([^.]*.[^.]*)$/; // matching ".nl" from the URL youngcapital.nl
  const matchDomainUrl = url.match(REGEX_GET_DOMAIN);
  const isNotLocalhost = !url.includes('localhost');
  const isNotStaging = !url.includes('staging');
  if (matchDomainUrl && isNotLocalhost && isNotStaging) {
    return matchDomainUrl[1];
  }
  return 'youngcapital.nl';
}

export function generateEmailFromDomain(domain) {
  if (domain.includes('co.uk')) {
    return 'info@studentjob.co.uk';
  }
  return `info@${domain}`;
}

export default function generateContactEmail() {
  const url = window.location.host;
  return generateEmailFromDomain(generateDomainFromUrl(url));
}
